import { render, staticRenderFns } from "./PatientDetailPage.vue?vue&type=template&id=f6faf4ea"
import script from "./PatientDetailPage.vue?vue&type=script&lang=js"
export * from "./PatientDetailPage.vue?vue&type=script&lang=js"
import style0 from "./PatientDetailPage.vue?vue&type=style&index=0&id=f6faf4ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports